//@flow
import { isEmail } from "validator"
// import { SubmissionError } from "redux-form"
import "isomorphic-fetch"
import { VALIDATE_EMAIL_ROUTE, callAPI } from "../API"
export const emailValidation = (value: string): ?string =>
  value && !isEmail(value) ? "Must be a valid email address" : undefined

export const validate = (options: { includePassword: boolean }) => (
  values: any
): any => {
  const errors = {}
  if (!values.name) {
    errors.name = "Cannot be blank."
  }
  if (!values.email) {
    errors.email = "Cannot be blank."
  } else {
    errors.email = emailValidation(values.email)
  }
  if (options.includePassword && !values.password) {
    errors.password = "Cannot be blank."
  } else if (options.includePassword && values.password.length < 6) {
    errors.password = "Must be at least 6 characters long!"
  }
  return errors
}

export const asyncValidate = async ({ email }: { email: string }) => {
  const response = await callAPI(VALIDATE_EMAIL_ROUTE, { email })
  const data = await response.json()
  if (data.errors && data.errors.state) {
    throw data.errors.state
  }
}



// WEBPACK FOOTER //
// ./src/PublicArea/validations.js